import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import * as ReactDOM from "react-dom";
import CommonModal from './Modal';
import { Button } from '../Button';

var ModalLocaleText = {
  okText: "OK",
  cancelText: "Cancel"
};

var ConfirmDialog = function ConfirmDialog(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var destroy = props.destroy,
      okText = props.okText,
      cancelText = props.cancelText,
      showCancelButton = props.showCancelButton,
      content = props.content,
      onOk = props.onOk,
      onCancel = props.onCancel,
      onClose = props.onClose,
      restProps = _objectWithoutProperties(props, ["destroy", "okText", "cancelText", "showCancelButton", "content", "onOk", "onCancel", "onClose"]);

  var toggle = function toggle() {
    if (onClose) {
      onClose();
    }

    setIsOpen(!isOpen);
    destroy();
  };

  var handleOk = function handleOk(e) {
    if (onOk) {
      onOk(e);
    }

    toggle();
  };

  var handleCancel = function handleCancel(e) {
    if (onCancel) {
      onCancel(e);
    }

    toggle();
  };

  var footer = /*#__PURE__*/React.createElement(React.Fragment, null, showCancelButton && /*#__PURE__*/React.createElement(Button, {
    btype: "basic",
    onClick: handleCancel
  }, cancelText || ModalLocaleText.cancelText), /*#__PURE__*/React.createElement(Button, {
    onClick: handleOk
  }, okText || ModalLocaleText.okText));
  return /*#__PURE__*/React.createElement(CommonModal, _extends({
    isOpen: isOpen,
    toggle: toggle,
    onOk: handleOk,
    onCancel: handleCancel,
    footer: footer
  }, restProps), content);
};

export default function confirm(props) {
  var div = document.createElement("div");
  document.body.appendChild(div);

  function destroy() {
    var unmountResult = ReactDOM.unmountComponentAtNode(div);

    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
  }

  function render(props) {
    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmDialog, _extends({}, props, {
      destroy: destroy
    })), div);
  }

  render(props);
}